export default __webpack_public_path__ + "static/media/ally_m3.387a1016.png";